import { treeAspect } from 'uix/views/utils';
import { isDigit } from 'ldash';
import { decodeSlimLink } from 'uix/utils';
// also allow code objects (datatype=18)
const wikiEnabled = ({ datatype, tconfig, dconfig })=>[
        1,
        18,
        10,
        21,
        23,
        25
    ].includes(datatype) || tconfig?.wikipage || datatype == 3 && (dconfig.transcription.on || dconfig.ocr.correction);
const deleteNonNumericId = (request, query, oldreq)=>{
    let deletable_id = request.classname !== 'xwiki' && request.id == oldreq.id && // only if routing tries to keep current id
    !isDigit(request.id) && !decodeSlimLink(request.id).otid;
    return deletable_id ? {
        request: {
            id: null
        }
    } : {};
};
export const xwiki = {
    ...treeAspect,
    acl: 'g:wiki',
    tabGroup: 'wiki',
    customizeRouting: deleteNonNumericId,
    tabs: {
        edit: {
            tabGroupDefault: true,
            default: true,
            enabled: wikiEnabled,
            parts: [
                {
                    type: 'WikiEditor',
                    showAlternatives: true
                }
            ]
        },
        history: {
            enabled: wikiEnabled,
            parts: [
                'WikiHistory'
            ]
        },
        view: {
            enabled: wikiEnabled,
            parts: [
                {
                    type: 'Wikiblock',
                    showAlternatives: true,
                    filters: [
                        'getWikiRendered'
                    ]
                }
            ]
        },
        search: {
            enabled: ({ datatype })=>[
                    0,
                    1,
                    2,
                    3,
                    10,
                    18,
                    21,
                    23,
                    25
                ].includes(datatype),
            parts: [
                'WikiSearch'
            ]
        }
    }
};
